module.exports = __webpack_public_path__ + "static/media/SAINT_6022.b925ab51.jpg";